// Central place for API base URLs so we can switch between
// local development and deployed environments without touching
// component code.

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

export const API_BASE = API_BASE_URL;
export const PROXY_BASE = API_BASE_URL;

